'use strict'

import chapterToggle from './chapter-toggle'
import initAll from './index'
import $ from 'jquery'

export function custom_group() {
	const $ = require('jquery')
	
	$('body').on('change', '#select_group', function () {
		if ($(this).val()) {
			$('#txt_group').val($(this).val())
		}
	})
	
	let initSelectGroup = function () {
		let url = $('#select_book_group').data('url')
		$('#content').addClass('loading')
		$.ajax({
			type: 'GET',
			url: url,
			data: {
				'group': $('#select_book_group').val(),
				'view_mode': $('#select_view_mode').val(),
				'slug': $('#txt_slug').val(),
				'secondLoad': true,
			},
		}).done(function (response) {
			let html = response.html
			// $('.book-contents').find('.section-remove').remove().fadeIn(2000)
			// $('.book-contents').append(html).fadeIn(2000)
			$('.book-contents').html(html).fadeIn(2000)
			$('#content').removeClass('loading ')
			initAll()
		}).fail(function (response) {
			$('#content').removeClass('loading')
		})
	}
	
	// if ($('#txt_load_book').val()) {
	// 	initSelectGroup()
	// }
	
	$('body').on('change', '#select_book_group', function () {
		initSelectGroup()
	})
	
	$('body').on('click', '.btn-group-option', function () {
		let url = $(this).data('url')
		let lang = $(this).data('lang')
		let title = $(this).data('text-content')
		let html = '<span style="font-size: 22px">' + title + '</span>'
		
		Swal.fire({
			title: html,
			icon: 'info',
			input: 'select',
			showLoaderOnConfirm: true,
			inputOptions: {
				1: $(this).data('text-all'),
				2: $(this).data('text-admin'),
				// 3: $(this).data('text-manager'),
				4: $(this).data('text-employee'),
			},
			inputPlaceholder: false,
			showCancelButton: true,
			inputValidator: (value) => {
				return new Promise((resolve) => {
					if (value) {
						$.ajax({
							type: 'GET',
							url: $(this).data('url-cache'),
							data: {
								lang,
								'group': value,
							},
						}).done(function (response) {
							window.location.href = url
						}).fail(function (response) {
						})
					} else {
						resolve($(this).data('text-require'))
					}
				})
			},
		})
	})
	$('body').on('change', '#select_view_mode', function () {
		let url = $(this).data('url')
		if ($(this).val() === '1') {
			$('#txt_view_all').val('1').trigger('change')
		}
		$('#content').addClass('loading')
		$.ajax({
			type: 'GET',
			url: url,
			data: {
				'group': $('#select_group').val(),
				'view_mode': $(this).val(),
				'slug': $('#txt_slug').val(),
				'secondLoad': true,
			},
		}).done(function (response) {
			let html = response.html
			$('.book-contents').find('.section-remove').remove().fadeIn(2000)
			$('.book-contents').append(html).fadeIn(2000)
			$('#content').removeClass('loading ')
			initAll()
		}).fail(function (response) {
			$('#content').removeClass('loading ')
		})
	})
}
